export interface Snippet {
  id: number;
  key: string;
  content: string;
  updatedAt: Date;
}

const DEFAULT_SNIPPET: Snippet = {
  id: -1,
  key: '',
  content: '',
  updatedAt: new Date(0),
};

export function DefaultSnippet(): Snippet {
  return JSON.parse(JSON.stringify(DEFAULT_SNIPPET));
}
